<template>
<v-dialog width="1000" v-model="show">
  <slot slot="activator" name="activator">
    <v-btn slot="activator">
      <v-icon>file_upload</v-icon>
    </v-btn>
  </slot>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('archive.add-file') }}
    </v-card-title>
    <v-container>
      <div>
        <v-select :items="allowedOperations" item-text="name" item-value="id" v-model="operation" :label="`${$t('base.operations')}`"></v-select>
        <v-text-field :label="`${$t('archive.choose_file')}`" @click="onPickFile" v-model='fileName' prepend-icon="attach_file"></v-text-field>
        <input type="file" style="display: none" ref="fileInput" :accept="getAllowedExtension()" @change="onFilePicked">
        <v-btn :disabled="!this.isValid()" @click="upload()">{{$t('archive.upload')}}</v-btn>
        <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-container>
  </v-card>
</v-dialog>
</template>

<script>
import http from '@/plugins/http'
const DEFAULT_ALLOWED_EXTENSION = ".csv"
export default {
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
      fileName: "",
      file: undefined,
      show: false,
      operation: undefined,
      allowedOperations: [],
      loading: false
    }
  },
  methods: {
    upload() {
      if (!this.isValid()) {
        return
      }

      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('operationId', this.operation)

      this.loading = true
      http.post('file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(data => {
        this.show = false
        this.$store.commit("setSnack", {
          message: this.$t("upload.success"),
          color: "success",
        })
      }).catch(() => {
        this.$store.commit("setSnack", {
          message: this.$t("upload.server_error"),
          color: "danger",
        })
      }).finally(() => this.loading = false)

    },
    isValid() {
      return this.file != undefined && this.fileName != undefined && this.loading == false
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {

        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        this.fileName = files[0].name
        this.file = files[0]

      } else {
        this.fileName = undefined
        this.file = undefined
      }
    },
    getAllowedExtension() {
      let operation = this.allowedOperations.find(el => el.id == this.operation)
      if (operation) {
        return operation.allowed_extension.map(ext => "." + ext).join(", ")
      }
      return DEFAULT_ALLOWED_EXTENSION
    }
  },
  created() {
    http.get('file/operations')
      .then(data => this.allowedOperations = data.data)
      .catch(() => {})
  }
}
</script>

<style>

</style>
